// hooks/use-portal-target.ts
import { useEffect, useState } from "react";

export function usePortalTarget(targetId: string) {
	const [target, setTarget] = useState<HTMLElement | null>(null);
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	useEffect(() => {
		if (!isClient) return;

		const findTarget = () => {
			const element = document.getElementById(targetId);
			if (element) {
				setTarget(element);
				return true;
			}
			return false;
		};

		// Try to find immediately
		if (findTarget()) return;

		// If not found, use MutationObserver to watch for it
		const observer = new MutationObserver(() => {
			if (findTarget()) {
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		// Also try with a slight delay as fallback
		const timeoutId = setTimeout(() => {
			findTarget();
		}, 100);

		// Cleanup
		return () => {
			observer.disconnect();
			clearTimeout(timeoutId);
		};
	}, [isClient, targetId]);

	return { target, isReady: isClient && !!target };
}
